@if (visible) {
  <div class="eop-consent-overlay">
    <div class="eop-consent-dialog">
      <h3>{{ 'COOKIE_BANNER.TITLE' | translate }}</h3>
      <p>
        {{ 'COOKIE_BANNER.DESCRIPTION' | translate }}
        <a [href]="dataProtectionUrl" target="_blank" rel="noopener">{{
          'COOKIE_BANNER.PRIVACY_LINK' | translate
        }}</a>
      </p>
      <p>
        {{ 'COOKIE_BANNER.DESCRIPTION_2' | translate }}
      </p>

      <div class="eop-consent-categories">
        @for (category of categories; track category.level) {
          <div class="eop-consent-category">
            <div class="eop-consent-category-header">
              <input
                type="checkbox"
                [id]="'eop-consent-cat-' + category.level"
                [checked]="category.accepted"
                [disabled]="category.required"
                (change)="toggleCategory(category)" />
              <label [for]="'eop-consent-cat-' + category.level">
                <strong>{{ category.titleKey | translate }}</strong>
              </label>
            </div>
            @if (showDetails) {
              <p class="eop-consent-category-description">
                {{ category.descriptionKey | translate }}
              </p>
              <ul class="eop-consent-category-bullets">
                @for (bullet of category.bulletKeys; track bullet) {
                  <li>{{ bullet | translate }}</li>
                }
              </ul>
            }
          </div>
        }
      </div>

      <div class="eop-consent-actions">
        <button
          class="eop-consent-btn eop-consent-btn--details"
          (click)="showDetails = !showDetails">
          {{
            (showDetails ? 'COOKIE_BANNER.HIDE_DETAILS' : 'COOKIE_BANNER.SHOW_DETAILS') | translate
          }}
        </button>
        <button class="eop-consent-btn eop-consent-btn--secondary" (click)="acceptSelected()">
          {{ 'COOKIE_BANNER.ACCEPT_SELECTED' | translate }}
        </button>
        <button class="eop-consent-btn eop-consent-btn--primary" (click)="acceptAll()">
          {{ 'COOKIE_BANNER.ACCEPT_ALL' | translate }}
        </button>
      </div>
    </div>
  </div>
}
